import { register } from 'register-service-worker'
import { BaseHook, BaseNotification } from '@/types'
import { createHooks } from '@/utils/hook-util'

enum StorageKey {
  UPDATED = 'serviceWorker.updated'
}

const SERVICE_WORKER_BASE_URL: string = process.env.BASE_URL
const SERVICE_WORKER_SUPPORT_REGISTRATION = (process.env.NODE_ENV === 'production')

const notificationHooks = createHooks<BaseNotification>()

export default class BaseServiceWorker {
  start(): void {
    if (!SERVICE_WORKER_SUPPORT_REGISTRATION) return

    Object.defineProperty(self, 'updateServiceWorker', {
      get: () => {
        localStorage.setItem(StorageKey.UPDATED, JSON.stringify(true))

        location.reload()
      }
    })

    register(`${SERVICE_WORKER_BASE_URL}service-worker.js`, {
      ready() {
        // eslint-disable-next-line no-console
        console.log('App is being served from cache by a service worker.')

        if (JSON.parse(localStorage.getItem(StorageKey.UPDATED) as string)) {
          localStorage.removeItem(StorageKey.UPDATED)

          notificationHooks.execute({
            title: 'app.notification.updatedServiceWorker',
            temporary: true,
            autoremove: true
          })
        }
      },
      registered() {
        // eslint-disable-next-line no-console
        console.log('Service worker has been registered.')
      },
      cached() {
        // eslint-disable-next-line no-console
        console.log('Content has been cached for offline use.')
      },
      updatefound() {
        // eslint-disable-next-line no-console
        console.log('New content is downloading.')
      },
      updated() {
        // eslint-disable-next-line no-console
        console.log('New content is available. Please reload app.')

        notificationHooks.execute({
          title: 'app.notification.updateServiceWorker',
          clickAction: 'javascript:self.updateServiceWorker;',
          clickTitle: 'app.button.update',
          uniqueKey: 'self.updateServiceWorker',
          temporary: true
        })
      },
      offline() {
        // eslint-disable-next-line no-console
        console.log('No internet connection found. App is running in offline mode.')
      },
      error(error) {
        // eslint-disable-next-line no-console
        console.error('Error during service worker registration: ', error)
      }
    })
  }

  registerNotificationHook(notificationHook: BaseHook<BaseNotification>): void {
    if (!SERVICE_WORKER_SUPPORT_REGISTRATION) return

    notificationHooks.register(notificationHook)
  }
}

export const baseServiceWorker = new BaseServiceWorker()